import { storableError } from '../../util/errors';
import { acceptOrganisationInvitation } from '../../util/api';
import { fetchCurrentUser } from '../../ducks/user.duck';

// ================ Action types ================ //

export const ACCEPT_INVITATION_REQUEST = 'app/JoinOrganisationPage/ACCEPT_INVITATION_REQUEST';
export const ACCEPT_INVITATION_SUCCESS = 'app/JoinOrganisationPage/ACCEPT_INVITATION_SUCCESS';
export const ACCEPT_INVITATION_ERROR = 'app/JoinOrganisationPage/ACCEPT_INVITATION_ERROR';
export const FETCH_MEMBERSHIP_REQUEST = 'app/JoinOrganisationPage/FETCH_MEMBERSHIP_REQUEST';
export const FETCH_MEMBERSHIP_COMPLETE = 'app/JoinOrganisationPage/FETCH_MEMBERSHIP_COMPLETE';

// ================ Reducer ================ //

const initialState = {
  acceptInProgress: false,
  /** @type {'success' | 'expired' | 'invalid_code' | 'already_in_org' | null} */
  result: null,
  acceptError: null,
  membershipFetchInProgress: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case ACCEPT_INVITATION_REQUEST:
      return { ...state, acceptInProgress: true, result: null, acceptError: null };
    case ACCEPT_INVITATION_SUCCESS:
      return { ...state, acceptInProgress: false, result: payload };
    case ACCEPT_INVITATION_ERROR:
      return { ...state, acceptInProgress: false, acceptError: payload };
    case FETCH_MEMBERSHIP_REQUEST:
      return { ...state, membershipFetchInProgress: true };
    case FETCH_MEMBERSHIP_COMPLETE:
      return { ...state, membershipFetchInProgress: false };
    default:
      return state;
  }
}

// ================ Thunk ================ //

export const acceptInvitation = (code) => {
  return (dispatch) => {
    dispatch({ type: ACCEPT_INVITATION_REQUEST });

    return acceptOrganisationInvitation({ code })
      .then((response) => {
        // v2 endpoint returns { status: 'success' | 'expired' | ... }
        dispatch({ type: ACCEPT_INVITATION_SUCCESS, payload: response.status });

        if (response.status === 'success') {
          dispatch({ type: FETCH_MEMBERSHIP_REQUEST });
          dispatch(fetchCurrentUser()).then(
            () => dispatch({ type: FETCH_MEMBERSHIP_COMPLETE }),
            () => dispatch({ type: FETCH_MEMBERSHIP_COMPLETE })
          );
        }
      })
      .catch((e) => {
        dispatch({ type: ACCEPT_INVITATION_ERROR, payload: storableError(e) });
      });
  };
};
